module.exports = __webpack_public_path__ + "img/help_vin.ef823af0.jpg";